export default __webpack_public_path__ + "static/media/gallery10.f05c31de.webp";